import React, { useEffect, useRef, useState } from 'react';
import { Card, CardContent, Container, Grid, Table, TableHead, TableRow, TableCell, TableBody, Typography, TableContainer, Box } from '@mui/material';

import DashboardCardTable from '../../../components/card/dashboard-permintaan-gudang/DashboardCardTable'

const DashboardPermintaanGudang: React.FC = () => {
    const tableRef = useRef<HTMLDivElement>(null);

    const [data, setData] = useState<any>([]);

    // Data dummy chart
    const datas = [
        { month: 'Jan', value: 20 },
        { month: 'Feb', value: 35 },
        { month: 'Mar', value: 40 },
        { month: 'Apr', value: 55 },
        { month: 'May', value: 30 },
    ];

    // Data dummy tabel
    const tableData = Array.from({ length: 30 }, (_, i) => ({
        no: i + 1,
        job: `Joblist ${i + 1}`,
        status: i % 2 === 0 ? 'Done' : 'Pending',
    }));

    // Auto scroll effect
    useEffect(() => {
        const el = tableRef.current;
        if (!el) return;

        let scrollDirection = 1;
        const interval = setInterval(() => {
            if (el.scrollTop + el.clientHeight >= el.scrollHeight) {
                scrollDirection = -1; // scroll ke atas
            } else if (el.scrollTop <= 0) {
                scrollDirection = 1; // scroll ke bawah
            }
            el.scrollTop += scrollDirection * 1; // kecepatan scroll
        }, 30);

        return () => clearInterval(interval);
    }, []);

    return (
        <Box
            sx={{
                height: "100vh",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                p: 2,
                bgcolor: "#f5f5f5",
                boxSizing: "border-box",
                overflow: "hidden", // ⬅️ mencegah scroll global
            }}
        >
            {/* HEADER */}
            <Card
                sx={{
                    textAlign: "center",
                    py: 2,
                    mb: 2,
                    flexShrink: 0,
                }}
            >
                <Typography
                    variant="h5"
                    fontWeight="bold"
                    sx={{
                        color: "#212121",
                    }}
                >
                    Dashboard Permintaan Gudang
                </Typography>
            </Card>

            {/* TABLE AREA */}
            <Box sx={{ flex: 1, width: "100%", overflow: "hidden" }}>
                <DashboardCardTable />
            </Box>
        </Box>
    );
};

export default DashboardPermintaanGudang;
